import { BaseError } from 'src/types/base-error';
import { Result } from 'src/types/result';
import { getErrorResult, getResult } from 'src/utils/result/utils';
import { isNilOrWhitespace } from 'src/utils/string';

export class AssetNamesError extends BaseError {
  constructor(context: { assetNames: string[] }) {
    super(
      'There must be at least one asset name, and names must be defined and unique',
      { context },
    );
  }
}

export const checkAssetNames = (
  assetNames: string[],
): Result<AssetNamesError, Set<string>> => {
  const uniqueAssetNames = new Set(assetNames);

  if (
    assetNames.length === 0 ||
    assetNames.some(isNilOrWhitespace) ||
    assetNames.length !== uniqueAssetNames.size
  ) {
    return getErrorResult(new AssetNamesError({ assetNames }));
  }

  return getResult(uniqueAssetNames);
};
